export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/drawer_button.62d9b029.svg","height":13,"width":18,"blurWidth":0,"blurHeight":0};